export default {
  admin: 'प्रशासक',
  password: {
    enterNewPassword: 'नया पासवर्ड दर्ज करें',
    reenterNewPassword: 'नए पासवर्ड को फिर से दर्ज करें',
    updatePassword: 'पासवर्ड अपडेट करें',
    setPassword: 'पासवर्ड सेट करें',
    min8CharacterMessage: 'पासवर्ड कम से कम 8 अक्षरों का होना चाहिए',
    passwordSentMessage: 'पासवर्ड {userName} को ईमेल के माध्यम से भेज दिया गया है।',
    generateNewPassword: 'नया पासवर्ड बनाएं',
    assignPasswordMessage:
      'उपयोगकर्ता के लिए पासवर्ड असाइन करें। उपयोगकर्ता को अगली लॉगिन पर यह पासवर्ड बदलने की आवश्यकता होगी।',
    generateSecurePassword: 'सुरक्षित पासवर्ड बनाएं',
    newPassword: 'नया पासवर्ड',
    confirmNewPassword: 'नए पासवर्ड की पुष्टि करें',
    passwordHistory: 'पासवर्ड इतिहास',
    passwordUpdatedLog: '{userName} द्वारा {date} को पासवर्ड अपडेट किया गया।',
    forgotPasswordLog: '{userName} द्वारा {date} को पासवर्ड भूलने का अनुरोध भेजा गया।',
  },
};
